export interface DerivativeAttachmentDto {
  id: string;
  operationId: string;
  fileName: string;
  fileSize: number;
  contentType: string;
  type: string | null; // "TradingNote" para Nota de Negociação, "SettlementLetter" para Carta de Liquidação
  createdAt: string;
  username: string;
  name: string;
  extension: string;
}

export interface DerivativeAttachmentUploadRequest {
  operationId: string;
  type?: string; // opcional: "TradingNote" para Nota de Negociação, "SettlementLetter" para Carta de Liquidação
  files: File[];
}

export enum DerivativeAttachmentType {
  TradingNote = 'TradingNote', // Nota de Negociação
  SettlementLetter = 'SettlementLetter', // Carta de Liquidação
}
